// extracted by mini-css-extract-plugin
export default {"secondary-column-cell":"secondary-column-cell_VWOqF","secondaryColumnCell":"secondary-column-cell_VWOqF","panel":"panel_ClnuH"};